import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
/** @jsxImportSource @emotion/react */
import { Button, CircularProgress } from '@mui/material';
/**
 * Same as the MUI button except passing `isLoading` will show a spinner in the center
 */
export function LoaderButton(props) {
    const { children, isLoading, disabled, ...rest } = props;
    return (_jsxs(Button, { ...rest, disabled: disabled || isLoading, css: { position: 'relative' }, children: [children, isLoading && (_jsx("span", { css: {
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate3d(-50%, calc(-50% + 2px), 0)',
                }, "aria-label": "Loading", children: _jsx(CircularProgress, { size: 24, color: "primary" }) }))] }));
}
